import React from 'react';
import { Link } from 'react-router-dom'; // Import Link

const ProductCard = ({ title, price, imageUrl, detailsLink }) => {
    // Assuming your detailsLink in productData is something like '/products/some-product-slug'
    const slug = detailsLink.split('/').pop(); // Extract the slug

    return (
        <div className="col" style={{ width: '305px', height: '390px' }}>
            <div className="card h-100 w-100 shadow-sm border-0">
                <Link to={`/products/${slug}`} className="text-decoration-none">
                    <img
                        src={imageUrl}
                        className="card-img-top"
                        alt={title}
                        onError={(e) => e.target.src='https://placehold.co/400x300/eee/ccc?text=Error'}
                        style={{ height: '265px' }}
                    />
                </Link>
                <div className="bg-white mx-0 d-flex flex-column justify-content-between w-100 h-100">
                    <h5 className="card-title fs-6 fw-semibold m-3 mb-4 text-dark text-truncate align-self-center">{title}</h5>
                    {price && <p className="card-text fw-bold text-primary mb-3">{price}</p>}
                    <Link to={`/products/${slug}`} className="btn bg-primary text-white m-0 rounded-0">View Details</Link>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;